import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=71dc60aa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71dc60aa')) {
      api.createRecord('71dc60aa', component.options)
    } else {
      api.reload('71dc60aa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=71dc60aa&", function () {
      api.rerender('71dc60aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NCam07jyV3U3/JS/pricehelp.vue"
export default component.exports